import React from 'react'
import { useTranslation } from 'react-i18next'
import type { TableRowV2 } from '@node-space/storybook-components/dist/SimpleTableV2'
import { Box, Box as Wrapper } from '@node-space/storybook-components/dist/Box'
import SimpleTableV2 from '@node-space/storybook-components/dist/SimpleTableV2'
import Loader from '@node-space/storybook-components/dist/Loader'
import { useWalletControllerContext } from 'hooks/useWalletControllerContext'
import { formatTotal } from './utils'
import { WalletTypes } from '../../../../types/types'

const rowHeaderWidth = 'px-8 w-1/3'

interface Props {
  showWalletTotal: boolean
  currencyType: WalletTypes
  convertWalletInfo: (value: WalletTypes) => TableRowV2[]
  testid?: string
}

const RowHeader = ({ showWalletTotal, currencyType, convertWalletInfo, testid }: Props) => {
  const { t } = useTranslation()

  const { isFetching, totalFiat, totalCrypto, baseCurrency, hasErrors } =
    useWalletControllerContext()

  const tableHeader = currencyType === ('FIAT' as WalletTypes) ? t('fiat') : t('cryptocurrency')
  return (
    <Wrapper className="mt-4">
      {convertWalletInfo(currencyType) && (
        <SimpleTableV2
          testid={testid}
          columns={[
            {
              headerTitle: tableHeader,
              className: rowHeaderWidth,
              testid: `${testid || 'simple-table-v2'}-column-${tableHeader}`,
            },
            {
              headerTitle: t('balance'),
              className: rowHeaderWidth,
              align: 'end',
              testid: `${testid || 'simple-table-v2'}-column-balance`,
            },
            {
              headerTitle:
                showWalletTotal &&
                (!isFetching ? (
                  t('totalBalance') +
                  ` ${formatTotal(
                    currencyType === ('FIAT' as WalletTypes) ? totalFiat : totalCrypto,
                    baseCurrency
                  )}`
                ) : (
                  <>
                    {!hasErrors && (
                      <Box flex justifyContent="center" alignItems="center" height="full">
                        <Loader theme="dark" size="small" />
                      </Box>
                    )}
                  </>
                )),
              align: 'end',
              className: rowHeaderWidth,
              testid: `${testid || 'simple-table-v2'}-column-total-balance`,
            },
          ]}
          tableData={convertWalletInfo(currencyType)}
        />
      )}
    </Wrapper>
  )
}

export default RowHeader
